import {create} from 'zustand'
import {DEFAULT_APP_VERSION} from '../const/const'

const useStore = create((set, get) => ({
    ver: DEFAULT_APP_VERSION,
    setVer: (ver) => set((state) => ({ver: ver})),

    devMode: false,
    setDevMode: (enable) => set((state) => ({devMode: enable})),

    shortVersion: false,
    setShortVersion: (enable) => set((state) => ({shortVersion: enable})),

    carId: null,
    setCarId: (carId) => set((state) => ({carId: carId})),
    availableMode: 0,
    setAvailableMode: (status) => set((state) => ({availableMode: status})),

    currentDate: null,
    startDate: null,
    startHours: null,
    finishDate: null,
    finishHours: null,
    setCurrentDate: (date) => set((state) => ({currentDate: date})),
    setStartDate: (date) => {
        if (!!date) {
            localStorage.setItem('b_date_start', `${date.getDate() < 10 ? '0' : ''}${date.getDate()}-${(date.getMonth() + 1) < 10 ? '0' : ''}${date.getMonth() + 1}-${date.getFullYear()}`);
        }
        set((state) => ({startDate: date}))
    },
    setStartHours: (hours) => {
        if (hours !== null && hours !== undefined) {
            localStorage.setItem('b_time_start', `${hours < 10 ? '0' : ''}${hours}:00`);
        }
        set((state) => ({startHours: hours}))
    },
    setFinishDate: (date) => {
        if (!!date) {
            localStorage.setItem('b_date_finish', `${date.getDate() < 10 ? '0' : ''}${date.getDate()}-${(date.getMonth() + 1) < 10 ? '0' : ''}${date.getMonth() + 1}-${date.getFullYear()}`);
        }
        set((state) => ({finishDate: date}))
    },
    setFinishHours: (hours) => {
        if (hours !== null && hours !== undefined) {
            localStorage.setItem('b_time_finish', `${hours < 10 ? '0' : ''}${hours}:00`);
        }
        set((state) => ({finishHours: hours}))
    },

    currentRate: null,
    ratesHide: false,
    setCurrentRate: (rateId) => set((state) => ({currentRate: rateId})),
    setRatesHide: (status) => set((state) => ({ratesHide: status})),

    currentInsurance: null,
    setCurrentInsurance: (insuranceId) => set((state) => ({currentInsurance: insuranceId})),

    carDeliveryLocation: null,
    carReturnLocation: null,
    setCarDeliveryLocation: (locationId) => set((state) => ({carDeliveryLocation: locationId})),
    setCarReturnLocation: (locationId) => set((state) => ({carReturnLocation: locationId})),

    carServices: [],
    isCheckedCarService: (serviceId) => {
        return !!get().carServices.filter((item) => item.serviceId === serviceId)?.length
    },
    checkCarService: (serviceId, name) => {
        const newCarServices = get().carServices.map(item => item);
        newCarServices.push({serviceId: serviceId, name: name})
        set((state) => ({...state, carServices: newCarServices}))
    },
    unCheckCarService: (serviceId) => {
        const newCarServices = get().carServices.filter((item) => item.serviceId !== serviceId);
        set((state) => ({...state, carServices: newCarServices}))
    },

    promoCode: '',
    isApplyPromoCode: false,
    promoCodeSale: 0,
    disableOtherDiscount: false,
    setPromoCode: (value) => set((state) => ({promoCode: value})),
    setPromoCodeSale: (value) => set((state) => ({promoCodeSale: value})),
    setIsApplyPromoCode: (value) => set((state) => ({isApplyPromoCode: value})),
    setDisableOtherDiscount: (value) => set((state) => ({disableOtherDiscount: value})),

    user: null,
    setUser: (data) => set((state) => ({user: data})),
    summaryHead: null,
    setSummaryHead: (data) => set((state) => ({summaryHead: data})),

    bonusPay: false,
    setBonusPay: (value) => set((state) => ({bonusPay: value})),

    sortSale: 0,
    setSortSale: (value) => set((state) => ({sortSale: value})),

    userName: '',
    userNameError: '',
    userTel: '',
    userTg: '',
    userTelError: '',
    userComment: '',
    setUserName: (value) => set((state) => ({userName: value})),
    setUserNameError: (value) => set((state) => ({userNameError: value})),
    setUserTel: (value) => set((state) => ({userTel: value})),
    setUserTg: (value) => set((state) => ({userTg: value})),
    setUserTelError: (value) => set((state) => ({userTelError: value})),
    setUserComment: (value) => set((state) => ({userComment: value})),

    promoHtml: '',
    setPromoHtml: (value) => set((state) => ({promoHtml: value})),

    isKz: false,
    setIskKz: (value) => set((state) => ({isKz: value})),

    countryCode: 'RU',
    setCountryCode: (value) => set((state) => ({countryCode: value})),

    lang: 'ru',
    setLang: (value) => set((state) => ({lang: value})),

    surcharge:null,
    setSurcharge: (value) => set((state) => ({surcharge: value})),

    workTime: null,
    setWorkTime: (value) => set((state) => ({workTime: value})),

    services: [],
    setServices: (value) => set((state) => ({services: Array.isArray(value) ? value : []})),

    payMethod: 'cash',
    setPayMethod: (value) => set((state) => ({payMethod: value})),

    periodSales: null,
    setPeriodSales: (value) => set((state) => ({periodSales: value})),
}))

export default useStore